(() => {
  const params = new URLSearchParams(location.search);
  const product = params.get('product');
  const sku = params.get('sku');
  const capacity = params.get('capacity');

  const body = document.querySelector('textarea[name="contact[body]"]');
  if (product && body && !body.value) {
    body.value = 'I am interested in ' + product.slice(0, 300) +
      (sku ? ' (SKU: ' + sku.slice(0, 80) + ')' : '') +
      '.\n\nRequired quantity:\nFinish / decoration:\nOther requirements:';
  }
  const capacityInput = document.querySelector('input[name="contact[Target Capacity]"]');
  if (capacity && capacityInput && !capacityInput.value) {
    capacityInput.value = capacity.slice(0, 120);
  }

  // Optional link prefill for the two advertising audiences; never override an explicit choice.
  const buyerValues = {
    brand: 'Beauty or fragrance brand',
    wholesale: 'Packaging wholesaler or distributor',
    wholesaler: 'Packaging wholesaler or distributor',
    distributor: 'Packaging wholesaler or distributor'
  };
  const buyer = (params.get('buyer') || '').trim().toLowerCase();
  const buyerSelect = document.querySelector('select[name="contact[Buyer Type]"]');
  if (buyerSelect && !buyerSelect.value && Object.prototype.hasOwnProperty.call(buyerValues, buyer)) {
    buyerSelect.value = buyerValues[buyer];
  }

  // Attribution is a self-reported link hint, not proof of Meta delivery.
  const channelNames = {
    facebook: 'Facebook',
    fb: 'Facebook',
    meta: 'Facebook',
    instagram: 'Instagram',
    ig: 'Instagram'
  };
  const source = (params.get('utm_source') || '').trim().toLowerCase();
  if (Object.prototype.hasOwnProperty.call(channelNames, source)) {
    const sourceInput = document.querySelector('input[name="contact[Campaign Source]"]');
    if (sourceInput) sourceInput.value = channelNames[source];
    const campaignInput = document.querySelector('input[name="contact[Campaign Name]"]');
    const campaign = (params.get('utm_campaign') || '').trim();
    if (campaignInput && campaign.length <= 80 && /^[a-zA-Z0-9 _.-]+$/.test(campaign)) {
      campaignInput.value = campaign;
    }
  }
})();

// "Send via WhatsApp": opens WhatsApp with the details typed so far. The email form still works on its own.
(() => {
  const fields = [
    ['Name', 'contact[name]'],
    ['Company / Brand', 'contact[Company / Brand]'],
    ['Email', 'contact[email]'],
    ['WhatsApp / Phone', 'contact[phone]'],
    ['I am sourcing as', 'contact[Buyer Type]'],
    ['Packaging format', 'contact[Product Type]'],
    ['Target capacity', 'contact[Target Capacity]'],
    ['Estimated quantity', 'contact[Estimated Quantity]'],
    ['Destination country', 'contact[Destination Country]'],
    ['Website / main market', 'contact[Website / Main Market]'],
    ['Decoration / closure', 'contact[Decoration / Closure Requirements]'],
    ['Details', 'contact[body]']
  ];
  document.querySelectorAll('.mio-quote__whatsapp[data-whatsapp]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = button.closest('form');
      const digits = (button.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
      if (!form || !digits) return;
      const lines = ['Hello MIOPACKS, I would like a packaging quote.'];
      fields.forEach(([label, name]) => {
        const input = form.querySelector('[name="' + name + '"]');
        const value = input ? input.value.trim() : '';
        if (value) lines.push(label + ': ' + value.slice(0, 1200));
      });
      lines.push('Page: ' + location.origin + location.pathname);
      const url = 'https://wa.me/' + digits + '?text=' + encodeURIComponent(lines.join('\n'));
      // window.open returns null when 'noopener' is passed, so clear opener on the returned window instead.
      const opened = window.open(url, '_blank');
      if (opened) opened.opener = null;
      else location.href = url;
    });
  });
})();
